// extracted by mini-css-extract-plugin
module.exports = {"insights-menu":"insights-menu___KK6H6","insights-menu-sections":"insights-menu-sections___-WKuT"};